import CellHero from "../components/CellHero";
import CellFocus from "../components/CellFocus";
import CellPathwayNav from "../components/CellPathwayNav";
import CellLeadership from "../components/CellLeadership";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function TextileMaterialsCellPage() {
  return (
    <main className="min-h-screen">
      <CellHero
        name="Textile Materials Cell"
        tagline="New Fibers, Blended Materials, and Sustainable Sourcing"
        description="The Textile Materials Cell drives innovation at the source — where fibers become yarn and raw materials become competitive advantage. It focuses on new fiber development, material diversification, and the transition to more sustainable inputs."
        icon="ri-stack-line"
      />

      <CellFocus
        focus={[
          "New fiber & yarn development",
          "Blended & technical textile materials",
          "Pre-consumer waste recycling",
          "Material diversification & MMF transition",
        ]}
        description="Bangladesh's textile sector is transitioning from cotton dominance to a diversified materials portfolio. This cell guides factories through new fiber adoption, blended material optimization, and circular sourcing strategies that meet buyer sustainability requirements."
      />

      <CellLeadership
        chiefCatalyst={{
          name: "Md. Azhar Ali",
          designation: "Chief Operating Officer, Salma Group",
        }}
        moderators={[
          {
            name: "Irin Akter",
            designation: "Former Global Technical Manager, Materials & Testing, G-Star Raw",
          },
        ]}
      />

      {/* Related Programmes */}
      <section className="bg-tie-navy py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/10 border border-white/20 mb-4 md:mb-5">
                  <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">
                    / Related Programmes
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                  Material Innovation Pathways
                </h2>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                { name: "PIIC", desc: "Materials-focused Innovation Circles for fiber and yarn trials", route: "/piic" },
                { name: "PIARC", desc: "Research on material properties, blends, and sustainability", route: "/piarc" },
                { name: "Training", desc: "Professional development for materials engineers and sourcing teams", route: "/training" },
                { name: "Expo", desc: "Textile Materials Innovation Expo showcasing next-gen fibers", route: "https://www.textileinnovationexpo.com/" },
              ].map((prog, index) => (
                <ScrollReveal key={prog.name} delay={index * 100}>
                  {prog.route.startsWith("http") ? (
                    <a href={prog.route} target="_blank" rel="noopener noreferrer" className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                      <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                      <p className="text-sm text-white/60">{prog.desc}</p>
                      <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                        Visit <i className="ri-external-link-line ml-1.5 text-xs" />
                      </span>
                    </a>
                  ) : (
                    <Link to={prog.route} className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                      <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                      <p className="text-sm text-white/60">{prog.desc}</p>
                      <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                        Learn more <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform" />
                      </span>
                    </Link>
                  )}
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CellPathwayNav />
    </main>
  );
}